export default {

  create() {
    // Products
    this.$products = Array.prototype.slice.call(this.$productList.querySelectorAll('.post-card'));
    this.$filteredProducts = this.$products;

    // Filters
    this.$filters = Array.prototype.slice.call(document.querySelectorAll('.js-search-bar input[type=checkbox]'));
    this.$textFilter = document.querySelector('.js-search-bar input[type=text]');
    this.$chipsContainer = document.querySelector('.products__chip-container');

    this.selectedFilters = [];
    this.textSearch = '';
    this.searchTimeOut = null;

    // Mobile toggle
    this.$filterToggleButton = document.querySelector('.js-toggle-tax-filters');
    this.$taxFilters = document.querySelector('.js-tax-filters');
    this.$overlay = document.querySelector('.page-overlay'),

    // Pagination
    this.productsPerPage = this.$productList.dataset.productsPerPage ? parseInt(this.$productList.dataset.productsPerPage) : 12;
    this.currentProductsPerPage = this.productsPerPage;
    this.$emptyState = document.querySelector('.js-empty-state');
    this.$moreButton = document.querySelector('.js-more-button');

    // searchparams
    this.urlSearchParams = 'URLSearchParams' in window ? new window.URLSearchParams(window.location.search) : null;
  },

  init() {
    this.$productList = document.querySelector('.js-product-list');

    if (!this.$productList) return;
    this.create();
    this.setInitialFilters();
    this.setActiveFilterchips();
    this.showProducts();
    this.toggleButton();


    this.$filters.forEach(filter => {
      filter.addEventListener('change', this.handleFilterSearch.bind(this))
    });
    this.$chipsContainer.addEventListener('click', this.handleFilterchipClick.bind(this));
    this.$textFilter.addEventListener('keydown', this.searchTimer.bind(this));
    this.$moreButton.addEventListener('click', this.handleMoreClick.bind(this));

    // Mobile filters
    this.$filterToggleButton.addEventListener('click', this.toggleMobileMenu.bind(this));
    this.$overlay.addEventListener('click', this.closeMobileMenu.bind(this));

    window.addEventListener('resize', this.closeMobileMenu.bind(this));
    document.addEventListener('keydown', event => {
      if (event.key === "Escape" || event.key === "Backspace") {
        this.closeMobileMenu();
      }
    });
  },

  render(animate = true) {
    if (animate) {
      this.$productList.classList.add('is-fade-out');
      // Prevent re-adding the class before the next paint is made and the animation isn't visible
      setTimeout(() => {
        this.setActiveFilterchips();
        this.showProducts();
        this.toggleButton();
        this.$productList.classList.remove('is-fade-out');
      }, 300);

    } else {
      this.setActiveFilterchips();
      this.showProducts();
      this.toggleButton();
    }
    this.$filterToggleButton.firstElementChild.innerHTML = this.selectedFilters.length ? this.selectedFilters.length : '&nbsp;';
  },

  toggleButton() {
    if (this.currentProductsPerPage >= this.$filteredProducts.length) {
      this.$moreButton.classList.add('u-hide');
    } else {
      this.$moreButton.classList.remove('u-hide');
    }
  },

  showProducts() {
    this.$products.forEach(product => product.parentNode.classList.add('u-hide'));
    if (this.$filteredProducts.length) {
      this.$filteredProducts.slice(0, this.currentProductsPerPage).forEach(product => {
        product.parentNode.classList.remove('u-hide');
      });
      this.$emptyState.classList.add('u-hide');
    } else {
      this.$emptyState.classList.remove('u-hide');
    }
  },

  setActiveFilterchips() {
    if (!this.selectedFilters.length) {
      this.$chipsContainer.innerHTML = '';
      this.$chipsContainer.classList.add('u-hide');
      return;
    }

    const $chips = this.selectedFilters.map(filter => {
      return `<button class="button button--chip" data-filter="${filter.value}">
                ${filter.dataset.name}
                <svg><use xlink:href="#icon-cancel-round"></use></svg>
              </button>`;
    });
    this.$chipsContainer.classList.remove('u-hide');
    this.$chipsContainer.innerHTML = '<span>filters:</span>' + $chips.join('');
  },

  filterProducts() {
    const $selectedProducts = this.filterByType(this.$products);
    this.$filteredProducts = this.filterByText($selectedProducts);
    this.resetPagination();
    this.render();
  },

  filterByType(products) {
    if (!this.selectedFilters.length) return products;

    return products.filter(product => {
      const productCategories = product.dataset.cat;
      if (!productCategories) return false;
      return this.selectedFilters.every(filter => {
        return (productCategories.indexOf(filter.value) !== -1);
      });
    })
  },

  filterByText(products) {
    if (!this.textSearch) return products;
    return products.filter(product => {
      const title = product.querySelector('.post-card__title').innerText;
      return title.toLowerCase().indexOf(this.textSearch) !== -1;
    });
  },

  updateFilters(event) {
    if (event.target.checked) {
      this.selectedFilters.push(event.target);
    } else {
      const filterIndex = this.selectedFilters.indexOf(event.target);
      if (filterIndex !== -1) {
        this.selectedFilters.splice(filterIndex, 1);
      }
    }
    this.updateFilterSearchParams();
    this.updateBrowserHistory();
  },

  updateFilterSearchParams() {
    if (this.urlSearchParams) {
      if (this.selectedFilters.length) {
        this.urlSearchParams.set('filter', this.selectedFilters.map(filter => filter.value));
      } else {
        this.urlSearchParams.delete('filter');
      }
    }
  },

  handleFilterSearch(event) {
    this.updateFilters(event);
    this.filterProducts();
  },

  /**
   * Slow down the keylistener to prevent animation flickering on typing search key.
   *
   * @param {Event} event
   */
  searchTimer(event) {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.handleTextSearch(event);
    }, 200);
  },

  handleTextSearch(event) {
    this.textSearch = event.target.value.toLowerCase();
    if (this.urlSearchParams) {
      if (this.textSearch) {
        this.urlSearchParams.set('search', this.textSearch);
      } else {
        this.urlSearchParams.delete('search');
      }
      this.updateBrowserHistory();
    }
    this.filterProducts();
  },

  handleMoreClick() {
    this.currentProductsPerPage += this.productsPerPage;
    this.render(false);
  },

  handleFilterchipClick(event) {
    const clickedFilterchip = event.target.dataset.filter || null;
    const index = this.selectedFilters.findIndex(filter => filter.value === clickedFilterchip);
    if (index !== -1 ) {
      this.selectedFilters[index].checked = false;
      this.selectedFilters.splice(index, 1);
      this.updateFilterSearchParams();
      this.updateBrowserHistory();
      this.filterProducts();
    }
  },

  resetPagination() {
    this.currentProductsPerPage = this.productsPerPage;
  },

  toggleMobileMenu() {
    if (this.$taxFilters.classList.contains('is-open')) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  },

  closeMobileMenu() {
    document.body.classList.remove('filtermenu-is-open');
    this.$taxFilters.classList.remove('is-open')
  },

  openMobileMenu() {
    document.body.classList.add('filtermenu-is-open');
    this.$taxFilters.classList.add('is-open')
  },

  /**
   * Set filters from the browsers url search params
   */
  setInitialFilters() {
    if (!this.urlSearchParams) return;

    if (this.urlSearchParams.has('search')) {
      this.textSearch = this.urlSearchParams.get('search');
      this.$textFilter.value = this.textSearch;
    }

    if (this.urlSearchParams.has('filter')) {
      const selectedFilters = this.urlSearchParams.get('filter').split(',');
      this.selectedFilters = this.$filters.filter($filter => $filter.value && selectedFilters.includes($filter.value))
      this.selectedFilters.forEach($activeFilter => $activeFilter.checked = true );
    }

    const $selectedProducts = this.filterByType(this.$products);
    this.$filteredProducts = this.filterByText($selectedProducts);
  },

  /**
   * Set search params in url
   */
   updateBrowserHistory(){
    const searchParams = this.urlSearchParams.toString();
    if (searchParams) {
      window.history.replaceState({}, '', window.location.pathname + '?' + searchParams);
    } else if (window.location.search) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  },
};
